import { useContext } from 'react'

import { PopoverBoundaryContext } from '../PopoverBoundary'

export function usePopoverBoundaryRef() {
  return useContext(PopoverBoundaryContext)
}
